import React, { useState } from "react";
import Tabs from "../../../components/Tabs/Tabs";

import { ReactComponent as SettingsIcon } from "../../../assets/icons/settings.svg";
import { ReactComponent as BackspaceIcon } from "../../../assets/icons/backspace.svg";
import { ReactComponent as DeleteIcon } from "../../../assets/icons/delete.svg";
import { ReactComponent as ConsoleIcon } from "../../../assets/icons/console.svg";
import { ReactComponent as PowerIcon } from "../../../assets/icons/power.svg";
import { ReactComponent as ArrowDownIcon } from "../../../assets/icons/arrow_down.svg";
import { ReactComponent as DesktopIcon } from "../../../assets/icons/desktop.svg";
import { ReactComponent as GameIcon } from "../../../assets/icons/game.svg";
import { ReactComponent as GeneralIcon } from "../../../assets/icons/general.svg";
import { ReactComponent as ProgramIcon } from "../../../assets/icons/program.svg";

import ActionListItem from "../ActionListItem";
import UserService from "../../../services/UserService";
import General from "../Shared/General";
import { NavLink, useHistory } from "react-router-dom";
import ActionButton from "../../../components/Buttons/ActionButton";
import Modal from "../../../components/Modals/ConfirmModal";
import Monitor from "../Shared/Monitor";
import Manual from "../Shared/Manual";
import Program from "../Shared/Program";
import Settings from "../Shared/Settings";
import Stream from "../Camera/Tabs/Stream";
import jetson_nano_tab_data from "../../../assets/mockedData/jetson_nano_tab_data";
import DeviceMenu from "../Shared/DeviceMenu";

type DeviceProp = {
  device: any;
};

const JetsonNano = (props: DeviceProp) => {
  const allowedProps = { test: "General" };
  const jetsonNanoTabData = jetson_nano_tab_data;
  const [activeTabId, setActiveTab] = useState();
  const type = props.device;
  console.log(props.device);
  const getActiveTabId = (e) => {
    setActiveTab(e);
  };
  console.log(activeTabId);
  const history = useHistory();
  console.log(history);
  history.push(`/devices/${type.id}/general`);

  return (
    <div className="device-main main-content">
      <div>
        <div className="header">
          <NavLink to="/devices" className="device-actions">
            <ArrowDownIcon />
          </NavLink>
          <h3 className="title">{props.device.name}</h3>
          <div className="list-item-actions main">
            <ActionButton
              icon={<PowerIcon />}
              className={`list-item-action ${props.device.Status && "online"}`}
            />
            <NavLink to={`/devices/${props.device.id}/logs`}>
              <ActionButton icon={<ConsoleIcon />} className="list-item-action logs-action" />
            </NavLink>
            <ActionButton icon={<DeleteIcon />} className="list-item-action" />
          </div>
        </div>
        {/* <NavLink to={`/devices/${props.device.id}/`}> */}
        {/* <Tabs data={jetsonNanoTabData}></Tabs> */}
        <DeviceMenu typeId={type.deviceTypes.id} />
        {/* </NavLink> */}
      </div>
    </div>
  );
};

export default JetsonNano;
